// Déplace le focus de `offset` positions (±1) parmi `items`, borné aux
// extrémités ; depuis un élément hors de la liste, va au premier. Un élément
// qui ne prend pas le focus (masqué, par exemple une entrée `visible-xs` en
// desktop) est sauté.
export function focusSibling(items: HTMLElement[], offset: number): void {
  const current = items.indexOf(document.activeElement as HTMLElement);

  for (
    let next = current === -1 ? 0 : current + offset;
    next >= 0 && next < items.length;
    next += offset
  ) {
    items[next].focus();

    if (document.activeElement === items[next]) return;
  }
}
